export * from './shjysswjbjscgdt.component';
export * from './detail/detail.component';
